import React from 'react';
import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material';

interface LoadingScreenProps {
  message?: string;
  fullScreen?: boolean;
  withProgress?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Loading...',
  fullScreen = true,
  withProgress = false // Disabled progress to prevent performance issues
}) => {
  const progress = 50; // Static progress value to avoid intervals

  // Removed problematic setInterval that was causing browser performance issues

  const content = (
    <>
      <CircularProgress size={40} aria-label={message || 'Loading'} />
      {message && (
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            color: 'text.secondary',
            fontSize: '0.875rem'
          }}
        >
          {message}
        </Typography>
      )}
      {withProgress && (
        <Box sx={{ width: '200px', mt: 2 }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            aria-label={message || 'Loading'}
            sx={{
              height: 2,
              borderRadius: 1,
              '& .MuiLinearProgress-bar': {
                borderRadius: 1,
              },
            }}
          />
        </Box>
      )}
    </>
  );

  if (!fullScreen) {
    return (
      <Box
        sx={{
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      {content}
    </Box>
  );
};

export default LoadingScreen;

